import React from "react";

export const CaptureBoundaryContext = React.createContext<ReadonlyArray<string>>([]);
